import { generateChannelCIDKey } from '../../../utils/generateChannelCIDKey';

import { initialHoveredChannel } from '../constants/initialStates';

export const normalizeChannelHovercard = (channel = []) => ({
  ...initialHoveredChannel,
  ...channel,
});

export const normalizeChannelHovercardList = (channelList = []) =>
  channelList.reduce(
    (accChannel, curChannel) => ({
      byId: {
        ...accChannel.byId,
        [generateChannelCIDKey(curChannel.channel)]:
          normalizeChannelHovercard(curChannel),
      },
      allIds: [...accChannel.allIds, curChannel.channel.id],
    }),
    {
      allIds: [],
      byId: {},
    },
  );
